import { TrendItemType } from "@/pages/dashboard/type";
import dayjs from "dayjs";

export const colorPalette = [
  "#8884d8",
  "#82ca9d",
  "#ffc658",
  "#ff7f50",
  "#87ceeb",
];

export const generateGraphColors = (data: TrendItemType[]) => {
  return data.map((collectedDataItem, index) => ({
    yAxisId: Object.keys(collectedDataItem)[0],
    stroke: colorPalette[index % colorPalette.length],
  }));
};

export const formattedDate = (oneDay: boolean, date: string) => {
  const formatString = oneDay ? "HH:mm" : "MMM D";
  const parsedDate = dayjs(date, "YYYY-MM-DD HH:mm", true);

  return parsedDate.isValid()
    ? parsedDate.format(formatString)
    : "Invalid date";
};
